import { createElement } from 'react';
import PageRender from './pageRender';
const CONFIG =
  process.env.NODE_ENV === 'development'
    ? require('./config.mock').default
    : require('./config').default;

function getQueryString(name) {
  const reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i');
  const r = window.location.search.slice(1).match(reg);
  if (r != null) {
    return decodeURIComponent(r[2]);
  }
  return null;
}

export default () => {
  let platformLang;
  const nvlang = navigator.language;
  const qs = getQueryString('lang');
  // 传进来的优先级最高
  if (qs) {
    platformLang = qs;
  } else {
    if (/^zh-/.test(nvlang)) {
      // 如果是中文
      let [lang, country] = nvlang.split('-');
      if (/^(cn|hk)$/i.test(country)) {
        // 如果国家/地区码是CN、HK
        country = country.toUpperCase();
      } else {
        // 其它地区码
        country = 'HK';
      }
      platformLang = [lang, country].join('_');
    } else if (/^en-/.test(nvlang)) {
      // 英语
      platformLang = 'en_US';
    } else if (/^th-/.test(nvlang)) {
      // 泰语
      platformLang = 'th_TH';
    } else if (/^(in-|id)/.test(nvlang)) {
      // 印尼语
      platformLang = 'in_ID';
    } else if (/^ko-/.test(nvlang)) {
      // 韩语
      platformLang = 'ko_KR';
    } else {
      platformLang = nvlang.split('-')[0];
    }
  }

  const loggerSiteNameMap = {
    WALLET_TMN: 'TRUEMONEY',
    WALLET_HK: 'ALIPAY_HK',
    WALLET_DANA: 'DANA',
    WALLET_TNGD: 'TNG',
    WALLET_GCASH: 'GCASH',
    WALLET_TOSS: 'TOSS',
  };

  window.iTracker.set({
    mdata: {
      uaLanguage: platformLang,
      chInfo: getQueryString('chInfo') || '',
      userIdentify: window.localStorage.getItem('ac-h5-userIdentify'),
      siteName:
        loggerSiteNameMap?.[window?.__IQUIC_PAGE_META?.bizExtInfo?.wallet],
    },
  });

  const blocks = CONFIG.blocks.map((block) => {
    const properties =
      block.properties.find((p) => p.language === platformLang) ||
      block.properties.find((p) => p.defaultProperty === true);

    const spaceProperties =
      block.spaceProperties?.[0]?.find((p) => p.language === platformLang) ||
      block.spaceProperties?.[0]?.find(
        (p) => p.language === properties?.language,
      );

    const { $spm, $bizTag, ..._properties } = properties?.properties || {};
    return {
      componentCode: block.template.code,
      isLayoutComponent: block.template.category === 'LAYOUT',
      data: {
        iquicInfo: {
          blockId: block.blockId,
          blockCode: block.blockCode,
          templateCode: block.template.code,
          templateVersion: block.template.version,
          bizTagData: { ...$bizTag },
          spmData: { ...$spm },
        },
        // 给 $spm 和 $bizTag 默认值
        renderData: {
          ..._properties,
          ...spaceProperties?.properties,
        },
      },
    };
  });

  return createElement(PageRender, {
    components: CONFIG.components,
    blocks,
  });
};
